// A LOGO CARRIES ITS OWN COLOUR, and a dark wordmark on the tile's dark ground
// disappears (Murdoch Mysteries, 2026-09-09: black letters on near-black).
// The tile asks the image how light it is, once, when it loads, and gives a
// dark mark a light ground. Transparent pixels are not the mark and are
// ignored; an image that is nearly all transparent tells us nothing.

/** Relative luminance (0–1) of the OPAQUE pixels of a loaded image, or null
 * when it cannot be measured (no canvas, a tainted image, nothing opaque). */
export function measureMarkLuminance(img: HTMLImageElement): number | null {
  try {
    const w = 24;
    const h = 24;
    const canvas = document.createElement('canvas');
    canvas.width = w;
    canvas.height = h;
    const ctx = canvas.getContext('2d');
    if (!ctx) return null;
    ctx.drawImage(img, 0, 0, w, h);
    const { data } = ctx.getImageData(0, 0, w, h);
    let sum = 0;
    let n = 0;
    for (let i = 0; i < data.length; i += 4) {
      const a = data[i + 3] ?? 0;
      if (a < 64) continue;
      const r = (data[i] ?? 0) / 255;
      const g = (data[i + 1] ?? 0) / 255;
      const b = (data[i + 2] ?? 0) / 255;
      sum += 0.2126 * r + 0.7152 * g + 0.0722 * b;
      n += 1;
    }
    if (n < (w * h) / 20) return null;
    return sum / n;
  } catch {
    return null;
  }
}

/** The threshold: below this a mark is dark enough to vanish on the tile's
 * ground and wants a light one. Grey marks near the middle stay on the dark
 * ground, which every logo tile shares by default. */
export function markIsDark(luminance: number): boolean {
  return luminance < 0.38;
}
